/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Identifies service contact type to include with response
 * @export
 * @enum {string}
 */
export enum IncludeServiceContactType {
    None = 'none',
    Primary = 'primary',
    ServiceTeam = 'serviceTeam',
    All = 'all'
}


export function IncludeServiceContactTypeFromJSON(json: any): IncludeServiceContactType {
    return IncludeServiceContactTypeFromJSONTyped(json, false);
}

export function IncludeServiceContactTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): IncludeServiceContactType {
    return json as IncludeServiceContactType;
}

export function IncludeServiceContactTypeToJSON(value?: IncludeServiceContactType | null): any {
    return value as any;
}

